/***
 * CHAT.WIDGET
 * Display chat at the bottom of the app
 */
import { useEffect, useRef } from "react"
import Chatra from "@chatra/chatra"
import { Session } from "@/redux/_session.types"
import { connect } from "react-redux"
import { useLocation } from "react-router-dom"

interface StateProps {
  _session: Session
}

function ChatWidget(props: StateProps) {
  //Get location
  const location = useLocation()
  const isChatInitialized = useRef(false)

  const isChatEnabled =
    props._session.language === "fr" &&
    !props._session.accountOptions.disableChat &&
    props._session.featureConnected === "survey" &&
    props._session.userRole === "ADMIN"

  //Init chat
  //DIsplay chat only if language is french and chat is active
  useEffect(() => {
    if (isChatEnabled && !isChatInitialized.current) {
      Chatra("init", {
        ID: "CRXxXCQN6cMqRbMRw",
        setup: {
          zIndex: 9,
          groupId: "QjXttMQTaakSxgz7b",
          buttonPosition: "bl",
          colors: {
            buttonText: "#1b759a" /* couleur du texte du bouton de chat */,
            buttonBg: "#95d5df" /* couleur de fond du bouton de chat */
          }
        }
      })
      isChatInitialized.current = true
    }
  }, [isChatEnabled])

  //Update params where location is change
  useEffect(() => {
    if (!isChatInitialized.current) return

    Chatra("updateIntegrationData", {
      currentPage: location.pathname
    })
  }, [location.pathname])

  //Update session params
  useEffect(() => {
    if (!isChatInitialized.current) return

    Chatra("updateIntegrationData", {
      email: props._session.email,
      phone: props._session.phone,
      accountName: props._session.accountName
    })
  }, [props._session.email, props._session.phone, props._session.accountName])

  return <div />
}

const mapStateToProps = (state) => ({
  _session: state._session
})

export default connect(mapStateToProps)(ChatWidget)
